import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import { Box, Container, Flex, Grid } from 'components/Layout'
import { Text } from 'components/Typography'
import { COLOR_INTENT, FONT_STACK, FONT_WEIGHT, SPACE } from 'Theme'
import { TRADE_VALUE_PROPS } from '../tradePerksData'
import { VALUE_PROP_ICONS } from './tradeIcons'

const { TRADE_PAGE } = COLOR_INTENT.WIDGETS

const Eyebrow = styled(Text)`
  text-transform: uppercase;
  letter-spacing: 0.28em;
`

const ValueProp = styled(Flex)`
  border-top: 1px solid ${TRADE_PAGE.DARK_BG};
`

const IconRing = styled(Flex)`
  flex: 0 0 auto;
  border-radius: 50%;
  border: 1px solid ${TRADE_PAGE.ICON_RING};
  align-items: center;
  justify-content: center;
  color: ${TRADE_PAGE.ACCENT};
`

export const TradeDoneRightSection: React.FC = () => (
  <Box
    backgroundColor={TRADE_PAGE.SECTION_BG}
    style={{ borderTop: `1px solid ${TRADE_PAGE.BORDER}` }}
  >
    <Container
      py={{ MOBILE: rem(52), TABLET: rem(84) }}
      px={{ MOBILE: SPACE.PX_24, TABLET: SPACE.PX_40 }}
    >
      <Text
        as="h2"
        fontFamily={FONT_STACK.SERIF}
        fontWeight={FONT_WEIGHT.NORMAL}
        fontSize={{ MOBILE: rem(28), TABLET: rem(34) }}
        color={TRADE_PAGE.HEADING}
        mb={{ MOBILE: SPACE.PX_24, TABLET: rem(40) }}
      >
        Trade, done right.
      </Text>

      <Grid
        gridTemplateColumns={{ MOBILE: '1fr', DESKTOP: 'repeat(4, 1fr)' }}
        gap={{ MOBILE: rem(22), DESKTOP: rem(28) }}
      >
        {TRADE_VALUE_PROPS.map((valueProp) => {
          const Icon = VALUE_PROP_ICONS[valueProp.icon]

          return (
            <ValueProp
              key={valueProp.title}
              flexDirection={{ MOBILE: 'row', DESKTOP: 'column' }}
              gap={{ MOBILE: rem(16), DESKTOP: 0 }}
              pt={{ MOBILE: rem(16), DESKTOP: rem(22) }}
            >
              <IconRing
                width={{ MOBILE: rem(40), DESKTOP: rem(44) }}
                height={{ MOBILE: rem(40), DESKTOP: rem(44) }}
                mb={{ MOBILE: 0, DESKTOP: rem(20) }}
              >
                <Icon size={19} />
              </IconRing>
              <Box>
                <Eyebrow
                  fontSize={{ MOBILE: rem(9.5), DESKTOP: rem(10) }}
                  fontWeight={FONT_WEIGHT.SEMI_BOLD}
                  color="#126554"
                  mb={{ MOBILE: rem(5), DESKTOP: SPACE.PX_8 }}
                >
                  {valueProp.eyebrow}
                </Eyebrow>
                <Text
                  as="h3"
                  fontSize={{ MOBILE: rem(15), DESKTOP: rem(16) }}
                  fontWeight={FONT_WEIGHT.BOLD}
                  color={TRADE_PAGE.TEXT_STRONG}
                  mb={{ MOBILE: SPACE.PX_6, DESKTOP: SPACE.PX_10 }}
                >
                  {valueProp.title}
                </Text>
                <Text
                  as="p"
                  fontSize={{ MOBILE: rem(13), DESKTOP: rem(13.5) }}
                  lineHeight="1.55"
                  color={TRADE_PAGE.TEXT_SOFT}
                  mb={0}
                >
                  {valueProp.desc}
                </Text>
              </Box>
            </ValueProp>
          )
        })}
      </Grid>
    </Container>
  </Box>
)
